/**
 * Little Heritage - Custom Wishlist
 * Stores saved products in localStorage (device/browser-based, no login required).
 * Storage shape: array of { handle, id } objects under key 'lh_wishlist'.
 */
(function () {
  const STORAGE_KEY = 'lh_wishlist';

  function getWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable, fail silently */
    }
    document.dispatchEvent(new CustomEvent('lh:wishlist-updated', { detail: { list } }));
  }

  function isSaved(handle) {
    return getWishlist().some((item) => item.handle === handle);
  }

  function toggle(handle, id) {
    const list = getWishlist();
    const index = list.findIndex((item) => item.handle === handle);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push({ handle, id });
    }
    saveWishlist(list);
    return index === -1; // true if just added, false if just removed
  }

  function updateButtonState(btn) {
    const handle = btn.dataset.productHandle;
    if (!handle) return;
    const saved = isSaved(handle);
    btn.classList.toggle('wishlist-button--active', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function refreshAllButtons() {
    document.querySelectorAll('.wishlist-button').forEach(updateButtonState);
  }

  function updateWishlistCount() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.wishlist-button');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    const handle = btn.dataset.productHandle;
    const id = btn.dataset.productId;
    if (!handle) return;

    toggle(handle, id);
    updateButtonState(btn);
    updateWishlistCount();
  });

  document.addEventListener('lh:wishlist-updated', updateWishlistCount);

  function init() {
    refreshAllButtons();
    updateWishlistCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose a tiny API for the wishlist page to use
  window.LHWishlist = {
    getWishlist,
    isSaved,
    toggle,
  };
})();
